import react, { useEffect } from "react";
// Fonts loaded via Google Fonts <link> in public/index.html
import SignIn from "./pages/Login";
import SignUp from "./pages/SignUp";
import Orders from "./pages/Orders";
import MenuPage from "./pages/MenuPage";

import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import { logPageView } from "./analytics";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import AddBusiness from "./pages/AddBusiness";
import Header from "./components/Header";
// import Manage from "./pages/Manage";
import ResetPassword from "./pages/ResetPassword";
import Landing from "./pages/Landing";
import LandingV2 from "./pages/LandingV2";
import About from "./pages/About";
import DishManageList from "./pages/DishManageList";
import uploadAdmin from "./pages/uploadAdmin";
import AudioNotification from "./components/AudioNotification";
import CookieBanner from "./components/CookieBanner";
import BussinessPage from "./pages/BusinessPage";
import ReservationPage from "./pages/ReservationPage";
import EditBusiness from "./pages/EditBusinessPage";
import ClaimLanding from "./pages/ClaimVenue/ClaimLanding";
import ClaimVerify from "./pages/ClaimVenue/ClaimVerify";
import ClaimAccount from "./pages/ClaimVenue/ClaimAccount";
import ClaimSuccess from "./pages/ClaimVenue/ClaimSuccess";
import VenueSearch from "./pages/ClaimVenue/VenueSearch";
import BrandClaimLanding from "./pages/ClaimBrand/BrandClaimLanding";
import BrandClaimAccount from "./pages/ClaimBrand/BrandClaimAccount";
import BrandClaimSuccess from "./pages/ClaimBrand/BrandClaimSuccess";
import AdminClaimReview from "./pages/AdminClaimReview";
import AdminDashboard from "./pages/AdminDashboard";
import Unsubscribe from "./pages/Unsubscribe";
import ManageVenueImages from "./pages/ManageVenueImages/ManageVenueImages";
import SquareSelectLocation from "./pages/SquareSelectLocation/SquareSelectLocation";
import UserAccountDetails from "./pages/UserAccountDetails";
import VenuePage from "./pages/VenuePage";
import VenuesPage from "./pages/VenuesPage";
import AccessibilityStatement from "./pages/AccessibilityStatement";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <Header />
      <Switch>
        {/* Public routes */}
        <Route path="/" exact component={LandingV2} />
        <Route path="/SignIn" exact component={SignIn} />
        <Route path="/SignUp" exact component={SignUp} />
        <Route path="/Reset" exact component={ResetPassword} />
        <Route path="/LandingPage" exact component={Landing} />
        <Route path="/About" exact component={About} />
        <Route path="/claim-venue/search" exact component={VenueSearch} />
        <Route path="/claim-venue/:venueId/success" exact component={ClaimSuccess} />
        <Route path="/claim-venue/:venueId/create-account" exact component={ClaimAccount} />
        <Route path="/claim-venue/:venueId/verify" exact component={ClaimVerify} />
        <Route path="/claim-venue/:venueId" exact component={ClaimLanding} />
        <Route path="/claim-brand/:brandId/success" exact component={BrandClaimSuccess} />
        <Route path="/claim-brand/:brandId/create-account" exact component={BrandClaimAccount} />
        <Route path="/claim-brand/:brandId" exact component={BrandClaimLanding} />
        <Route path="/unsubscribe" exact component={Unsubscribe} />
        <Route path="/venues" exact component={VenuesPage} />
        <Route path="/venues/:bizId" exact component={VenuePage} />
        <Route path="/accessibility-statement" exact component={AccessibilityStatement} />

        {/* Authenticated routes */}
        <PrivateRoute path="/Home" exact component={Home} />
        <PrivateRoute path="/Orders/:id" component={Orders} />
        <PrivateRoute path="/DishDetails/:id/:menuId" component={DishManageList} />
        <PrivateRoute path="/Manage/:id" component={MenuPage} />
        <PrivateRoute path="/Bussiness/:id" component={BussinessPage} />
        <PrivateRoute path="/editBusiness/:id/images" exact component={ManageVenueImages} />
        <PrivateRoute path="/editBusiness/:id" component={EditBusiness} />
        <PrivateRoute path="/integrations/square/select-location" exact component={SquareSelectLocation} />
        <PrivateRoute path="/AddBusiness" exact component={AddBusiness} />
        <PrivateRoute path="/reservations/:id" exact component={ReservationPage} />
        <PrivateRoute path="/account" exact component={UserAccountDetails} />

        {/* Admin routes */}
        <AdminRoute path="/UploadAdmin" exact component={uploadAdmin} />
        <AdminRoute path="/admin/dashboard" exact component={AdminDashboard} />
        <AdminRoute path="/admin/claim-reviews" exact component={AdminClaimReview} />

        <Route component={NotFound} />
      </Switch>
      <AudioNotification />
      <CookieBanner />
    </Router>
  );
}

export default App;
